<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); let idx = index; trackBy: trackByFunc">
		<button *ngIf="!isDefaultFilter" type="button" mat-icon-button class="circle-icon-remove" (click)="removeValue(idx)"><mat-icon color="accent" svgIcon="md:remove"></mat-icon></button>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-box" subscriptSizing="dynamic">
			<mat-label>{{filter.placeholderFrom}}</mat-label>
			<input matInput
					pattern="[0-9 ]*"
					(ngModelChange)="checkValidationFrom($event, idx)"
					[ngModel]="filter.getValues()[idx].from"
					[attr.aria-label]="filter.label + ' ' + filter.placeholderFrom"
			>
		</mat-form-field>
		<mat-form-field appearance="outline" class="copo-no-error-message filter-box" subscriptSizing="dynamic">
			<mat-label>{{filter.placeholderTo}}</mat-label>
			<input matInput
					pattern="[0-9 ]*"
					(ngModelChange)="checkValidationTo($event, idx)"
					[ngModel]="filter.getValues()[idx].to"
					[attr.aria-label]="filter.label + ' ' + filter.placeholderTo"
			>
		</mat-form-field>
		<mat-error *ngIf="!isValid[idx] && isValid[idx] !== undefined" translate>filter.field.invalid</mat-error>
	</div>
</ng-container>